// removed by extract-text-webpack-plugin
module.exports = {"table-header__hidden":"nrk-datasettsok-table-header__hidden","tableHeaderHidden":"nrk-datasettsok-table-header__hidden"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Main/Rows/TableHeader.css
// module id = 180
// module chunks = 0